<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading">
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="cf-dlg-loading__text">Cargando...</p>
  </div>
</ng-container>

<ng-container *ngIf="ready">

  <div class="dlg-hdr">
    <div class="dlg-hdr__title">
      <div class="dlg-hdr__icon-wrap"><mat-icon>account_balance</mat-icon></div>
      <div>
        <span>{{ isEditMode ? 'Editar póliza de crédito' : 'Nueva póliza de crédito' }}</span>
      </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dlg-body">

    <ng-container *ngIf="saved === false">

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Banco</mat-label>
        <mat-icon matPrefix style="margin-right:8px;color:#6b7280">account_balance</mat-icon>
        <input type="text" matInput [(ngModel)]="polizaCredito.banco" required
          [matAutocomplete]="autoBanco"
          (input)="onBancoInput($event.target['value'])">
        <mat-autocomplete #autoBanco="matAutocomplete">
          <mat-option *ngFor="let bic of filteredBancos; trackBy: trackByIndex" [value]="bic.bank" (onSelectionChange)="onBancoSelected(bic)">
            <span>{{ bic.bank }}</span>
            <span style="color:#6b7280;font-size:12px;margin-left:8px">{{ bic.bic }}</span>
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="invalidBanco">Campo requerido</mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>BIC / SWIFT</mat-label>
        <input matInput [(ngModel)]="polizaCredito.bic"
          [formControl]="bicsCtrl" [matAutocomplete]="auto" required>
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let bic of filteredBics | async; trackBy: trackByIndex" [value]="bic.bic">
            <span>{{ bic.bic }}</span>
            <span style="color:#6b7280;font-size:12px;margin-left:8px">{{ bic.bank }}</span>
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="invalidBic">{{ invalidBicMsg }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>IBAN</mat-label>
        <input type="text" matInput [(ngModel)]="polizaCredito.iban" required
          style="text-transform:uppercase" (input)="polizaCredito.iban = polizaCredito.iban.toUpperCase()">
        <mat-error *ngIf="invalidIban">Campo requerido</mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Límite de crédito</mat-label>
        <mat-icon matPrefix style="margin-right:8px;color:#6b7280">attach_money</mat-icon>
        <input type="text" matInput [(ngModel)]="polizaCredito.limite" required numberDecimalsDirective>
        <mat-error *ngIf="invalidLimite">Campo requerido</mat-error>
      </mat-form-field>

      <div *ngIf="isEditMode" style="display:flex;align-items:center;gap:12px;margin-top:4px;margin-bottom:8px">
        <button mat-stroked-button (click)="showApiKey = !showApiKey" type="button">
          <mat-icon>{{ showApiKey ? 'visibility_off' : 'visibility' }}</mat-icon>
          {{ showApiKey ? 'Ocultar UID' : 'Ver UID' }}
        </button>
        <span *ngIf="showApiKey" style="font-family:monospace;font-size:12px;color:#6b7280">{{ polizaCredito.uid }}</span>
      </div>

    </ng-container>

    <div class="delete-info delete-info--success" *ngIf="saved === true">
      <mat-icon>check_circle</mat-icon>
      <div class="delete-info__text">
        Póliza de crédito {{ isEditMode ? 'actualizada' : 'creada' }} correctamente.
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dlg-actions">
    <button mat-stroked-button (click)="closeDialog()">
      {{ saved ? 'Cerrar' : 'Cancelar' }}
    </button>
    <button *ngIf="saved === false" mat-flat-button class="dlg-btn-save" (click)="save()">
      <mat-icon>save</mat-icon>
      {{ isEditMode ? 'Actualizar' : 'Crear' }}
    </button>
  </mat-dialog-actions>

</ng-container>
